var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackSrch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.91 10.86C15.91 13.9252 13.4252 16.41 10.36 16.41C7.2948 16.41 4.80999 13.9252 4.80999 10.86C4.80999 7.7948 7.2948 5.30999 10.36 5.30999C13.4252 5.30999 15.91 7.7948 15.91 10.86ZM15.0071 17.0627C13.7123 18.0343 12.1034 18.61 10.36 18.61C6.07978 18.61 2.60999 15.1402 2.60999 10.86C2.60999 6.57978 6.07978 3.10999 10.36 3.10999C14.6402 3.10999 18.11 6.57978 18.11 10.86C18.11 12.6034 17.5343 14.2123 16.5628 15.5071L21.3878 20.3321L19.8322 21.8878L15.0071 17.0627Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackSrch);
export default __webpack_public_path__ + "static/media/black_srch.fff514d3ac785e132b1d9b9b008d737d.svg";
export { ForwardRef as ReactComponent };